import { motion } from "framer-motion";
import { Sigma, FlaskConical, Atom, ArrowUpRight } from "lucide-react";
import { COURSES } from "../../lib/content";
import { MaskLine, SectionLabel } from "./Reveal";

const ICONS = { sigma: Sigma, flask: FlaskConical, atom: Atom };

export default function Courses() {
  return (
    <section id="courses" data-testid="courses-section" className="relative bg-ink text-white py-24 lg:py-32 noise overflow-hidden">
      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <SectionLabel dark>Courses Offered</SectionLabel>
        <h2 className="font-heading font-extrabold tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[1]">
          <MaskLine>What we teach,</MaskLine>
          <MaskLine delay={0.1} className="text-stroke">and teach well.</MaskLine>
        </h2>

        <div className="mt-14 grid md:grid-cols-3 gap-4">
          {COURSES.map((c, i) => {
            const Icon = ICONS[c.icon];
            return (
              <motion.div
                key={c.title}
                data-testid={`course-card-${i}`}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-10%" }}
                transition={{ duration: 0.6, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
                whileHover={{ y: -6 }}
                className="group relative border border-white/15 bg-white/[0.03] p-8 hover:bg-white/[0.06] hover:border-flame/60 transition-colors duration-300"
              >
                <div className="flex items-start justify-between">
                  <span className="grid place-items-center h-14 w-14 rounded-xl bg-flame/15 text-flame group-hover:bg-flame group-hover:text-white transition-colors duration-300">
                    <Icon className="h-7 w-7" />
                  </span>
                  <ArrowUpRight className="h-5 w-5 text-white/30 group-hover:text-flame transition-colors" />
                </div>
                <div className="mt-6 text-[11px] uppercase tracking-[0.2em] text-flame font-semibold">
                  {c.tag}
                </div>
                <h3 className="mt-2 font-heading font-bold text-2xl">{c.title}</h3>
                <p className="mt-3 text-white/60 text-sm leading-relaxed">{c.desc}</p>
                <ul className="mt-6 space-y-2">
                  {c.points.map((p) => (
                    <li key={p} className="flex items-center gap-2 text-sm text-white/75">
                      <span className="h-1.5 w-1.5 rounded-full bg-flame" /> {p}
                    </li>
                  ))}
                </ul>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
